import * as React from 'react'
import { ScreensAuth } from './AuthStack'
import { Dashboard } from '../screens/Dashboard/Dashboard'
import { OnboardingScreen } from '../screens/OnboardingScreen/OnboardingScreen'
import { TransitionScreen } from '../screens/OnboardingScreen/TransitionScreen'
import { Constructions } from '../screens/ConstructionScreens/Constructions'
import { ConstructionsImageDetail } from '../screens/ConstructionScreens/ConstructionsImageDetail'
import { Finance } from '../screens/FinanceScreens/Finance'
import { PayInstallmentScreen } from '../screens/FinanceScreens/PayInstallmentScreen'
import { DuplicateScreen } from '../screens/FinanceScreens/DuplicateScreen'
import { AnticipateInstallmentScreen } from '../screens/FinanceScreens/AnticipateInstallmentScreen'
import { NotificationsScreen } from '../screens/NotificationsScreen/NotificationsScreen'
import { AppointmentsScreen } from '../screens/AppointmentsScreen/AppointmentsScreen'
import { ProfileScreen } from '../screens/ProfileScreens/ProfileScreen'
import { ChangeNameScreen } from '../screens/ProfileScreens/ChangeNameScreen'
import { GenericInfoScreen } from '../screens/ProfileScreens/GenericInfoScreen'
import { getGenericInfoScreenHeaderTitle } from '../screens/ProfileScreens/constants'
import { ChangePasswordScreen } from '../screens/ProfileScreens/ChangePasswordScreen'
import { AssistanceScreen } from '../screens/AssistanceScreens/AssistanceScreen'
import { QuestionScreen } from '../screens/AssistanceScreens/QuestionsScreen'
import { AnswerScreen } from '../screens/AssistanceScreens/AnswerScreen'
import { ATLButton, ButtonTypeEnum, TextCaseEnum } from '@appsimples/atlantica-react-native'
import { icons } from '../constants/searchAssets'
import { atlTheme } from '../atlTheme'
import { Coordinator } from './coordinator/coordinator'

export const ConstructionScreenNames = {
  Documents: 'Documents',
  Media: 'Media',
  Progress: 'Progress',
}
export const FinanceScreenNames = {
  Bills: 'Bills',
  Future: 'Future',
  AnticipateInstallment: 'AnticipateInstallment',
  PayInstallment: 'PayInstallment',
  Duplicate: 'Duplicate',
}
export const MainStackScreenNames = {
  Answers: 'Answers',
  Appointments: 'Appointments',
  Assistance: 'Assistance',
  ChangeName: 'ChangeName',
  ChangePassword: 'ChangePassword',
  Constructions: 'Constructions',
  ConstructionsImageDetail: 'ConstructionsImageDetail',
  Dashboard: 'Dashboard',
  Finance: 'Finance',
  GenericCompanyInfo: 'GenericCompanyInfo',
  Onboarding: 'Onboarding',
  Profile: 'Profile',
  Questions: 'Questions',
  Transition: 'Transition',
  Notifications: 'Notifications',
}

export const MainStack = Stack => [
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Dashboard}`}
    name={MainStackScreenNames.Dashboard}
    component={Dashboard}
    options={Dashboard.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Appointments}`}
    name={MainStackScreenNames.Appointments}
    component={AppointmentsScreen}
    options={AppointmentsScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Constructions}`}
    name={MainStackScreenNames.Constructions}
    component={Constructions}
    options={Constructions.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.ConstructionsImageDetail}`}
    name={MainStackScreenNames.ConstructionsImageDetail}
    component={ConstructionsImageDetail}
    options={ConstructionsImageDetail.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Finance}`}
    name={MainStackScreenNames.Finance}
    component={Finance}
    options={Finance.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Onboarding}`}
    name={MainStackScreenNames.Onboarding}
    component={OnboardingScreen}
    options={OnboardingScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Transition}`}
    name={MainStackScreenNames.Transition}
    component={TransitionScreen}
    options={TransitionScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${FinanceScreenNames.PayInstallment}`}
    name={FinanceScreenNames.PayInstallment}
    component={PayInstallmentScreen}
    options={PayInstallmentScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${FinanceScreenNames.Duplicate}`}
    name={FinanceScreenNames.Duplicate}
    component={DuplicateScreen}
    options={DuplicateScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${FinanceScreenNames.AnticipateInstallment}`}
    name={FinanceScreenNames.AnticipateInstallment}
    component={AnticipateInstallmentScreen}
    options={AnticipateInstallmentScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Notifications}`}
    name={MainStackScreenNames.Notifications}
    component={NotificationsScreen}
    options={NotificationsScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Assistance}`}
    name={MainStackScreenNames.Assistance}
    component={AssistanceScreen}
    options={AssistanceScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Questions}`}
    name={MainStackScreenNames.Questions}
    component={QuestionScreen}
    options={navigation => ({
      ...QuestionScreen.navigationOptions,
      headerTitle: navigation.route.params.category,
    })}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Answers}`}
    name={MainStackScreenNames.Answers}
    component={AnswerScreen}
    options={navigation => ({
      ...AnswerScreen.navigationOptions,
      headerTitle: navigation.route.params.category,
      headerLeft: () => (
        <ATLButton
          type={ButtonTypeEnum.label}
          title={''}
          horizontalMargin={-1}
          buttonBaseProps={{
            icon: icons.chevronLeft,
            iconSize: atlTheme.SizeIconBase,
            textCase: TextCaseEnum.none,
            textColorRegular: atlTheme.ColorBrand1Default,
          }}
          onPress={() => Coordinator.goToQuestions(navigation.route.params.category)}
        />
      ),
    })}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.Profile}`}
    name={MainStackScreenNames.Profile}
    component={ProfileScreen}
    options={ProfileScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.ChangeName}`}
    name={MainStackScreenNames.ChangeName}
    component={ChangeNameScreen}
    options={ChangeNameScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.ChangePassword}`}
    name={MainStackScreenNames.ChangePassword}
    component={ChangePasswordScreen}
    options={ChangePasswordScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${MainStackScreenNames.GenericCompanyInfo}`}
    name={MainStackScreenNames.GenericCompanyInfo}
    component={GenericInfoScreen}
    options={navigation => ({
      ...GenericInfoScreen.navigationOptions,
      headerTitle: getGenericInfoScreenHeaderTitle(navigation.route.params.context),
      headerLeft: () => (
        <ATLButton
          type={ButtonTypeEnum.label}
          title={''}
          horizontalMargin={-1}
          buttonBaseProps={{
            icon: icons.chevronLeft,
            iconSize: atlTheme.SizeIconBase,
            textCase: TextCaseEnum.none,
            textColorRegular: atlTheme.ColorBrand1Default,
          }}
          onPress={navigation.route.params.hasSignUpScreenAsOrigin ? Coordinator.goToSignUp : Coordinator.goToProfile}
        />
      ),
    })}
  />,
]
